import { createAction } from '@reduxjs/toolkit';

export const clearReduxStoreAction = createAction('global/clearReduxStoreAction');
